// extracted by mini-css-extract-plugin
module.exports = {"section_header":"sectionheader_section_header__2VSP7","left_sec":"sectionheader_left_sec__193SK","right_sec":"sectionheader_right_sec__1kWDN"};